export default __webpack_public_path__ + "static/media/WhiteArrow.94cf0308.svg";